module.exports = __webpack_public_path__ + "img/download.003402a7.svg";